import React, {
  useEffect,
  useState,
} from "react";

import jwt_decode from "jwt-decode";

import {
  FaExchangeAlt,
} from "react-icons/fa";

import AddMovimiento from "../components/AddMovimiento";
import TableMovimientos from "../components/TableMovimientos";
import Footer from "../components/Footer";

import "../css/admin.css";
import "../css/movimientos.css";

const Movimientos = () => {
  const [
    usuario,
    setUsuario,
  ] = useState({});

  const [
    show,
    setShow,
  ] = useState(false);

  const token =
    localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode =
          jwt_decode(token);

        setUsuario(
          token_decode.usuario
        );
      } catch (e) {
        console.error(
          "❌ Error al decodificar token:",
          e
        );

        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <main className="mov2-page">
        {token ? (
          usuario?.role ===
          "ADMIN_ROLE" ? (
            <>
              <section className="mov2-header">
                <div className="mov2-header-icon">
                  <FaExchangeAlt />
                </div>

                <div className="mov2-header-text">
                  <span>
                    TESORERÍA
                  </span>

                  <h1>
                    Gestión de Movimientos
                  </h1>

                  <p>
                    Control de ingresos,
                    egresos y movimientos
                    asociados a cajas,
                    bancos, viajes y gastos.
                  </p>
                </div>
              </section>

              <div className="mov2-actions">
                <AddMovimiento
                  setShow={setShow}
                  show={show}
                />
              </div>

              {!show && (
                <TableMovimientos />
              )}
            </>
          ) : (
            <div
              className="alert alert-info"
              role="alert"
            >
              Lo sentimos, pero no tiene
              permisos para acceder a este
              contenido.
            </div>
          )
        ) : (
          <div
            className="alert alert-danger"
            role="alert"
          >
            No se encuentra logueado en la
            plataforma.
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Movimientos;